/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportMachineStarts } from './reportMachineStarts';
import { ReportEnergy } from './reportEnergy';
import { ReportLiquidsProcessed } from './reportLiquidsProcessed';
import { ReportVibration } from './reportVibration';
import { ReportAlarmEntry } from './reportAlarmEntry';
import { ReportMachineUtilization } from './reportMachineUtilization';


export interface ReportData { 
    last_service?: string;
    next_service?: string;
    machine_starts?: ReportMachineStarts;
    machine_utilization?: ReportMachineUtilization;
    energy?: ReportEnergy;
    liquids_processed?: ReportLiquidsProcessed;
    alarms?: Array<ReportAlarmEntry>;
    vibration?: ReportVibration;
}

